import { createClient, SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey)

// The schema lives in `migrations/`, applied in order. It used to be kept here
// too, as ~540 lines of commented-out SQL headed "run this in the SQL editor",
// and the two had long since diverged.
//
// That copy was worth deleting rather than updating. It still described the
// policies that caused the anon-read exposure closed in 0023 — `for select
// using (true)` on proposals and brand_strategies, `for all using (auth.jwt()
// ->> 'email' = ...)` with the admin address written out by hand — presented as
// the thing to paste into a live database. Anyone reaching for it would have
// reintroduced, verbatim, what those migrations were written to remove.
//
// `git log -- src/lib/supabase.ts` has it if the history is ever wanted.
